// booking.js: API for booking submission
import api from './api';

export async function submitBooking(data) {
  const res = await api.post('/api/bookings', data);
  return res.data;
}
